export default {
    computed:{
        isLatinLetter(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[A-Za-z\s]+$/.test(char)) return true;
          
        },
    },
    watch:{
       
         
    },
    methods: {
        $helloGlobalMixin(event) {
          console.log("global mixin");
          console.log(event.target);
        }
      }
}